/** Llamadas al endpoint que envuelve la API Siete del Banco Central de Chile. */
import { apiRequest } from "../../lib/api";

export interface IndiceIpcResponse {
  anio: number;
  mes: number;
  fecha: string; // YYYY-MM-DD
  valor: string; // Decimal serializado
  serie: string;
  fuente: string;
}

export function fetchIndiceIpc(
  anio: number,
  mes: number,
): Promise<IndiceIpcResponse> {
  return apiRequest<IndiceIpcResponse>(`/api/v1/ipc/${anio}/${mes}`);
}

/** Extrae (año, mes) desde un valor `YYYY-MM-DD`. Devuelve null si no calza. */
export function parseMes(s: string): { anio: number; mes: number } | null {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-\d{2}$/.exec(s);
  if (!m) return null;
  const anio = Number(m[1]);
  const mes = Number(m[2]);
  if (!Number.isFinite(anio) || !Number.isFinite(mes)) return null;
  if (mes < 1 || mes > 12) return null;
  return { anio, mes };
}
